/*
 * @Author: your name
 * @Date: 2021-11-11 13:10:32
 * @LastEditTime: 2022-04-01 21:12:05
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\components\tabbar\index.js
 */
export default{
    data() {
        return {
            navbar: {
                title: '数字化全域经销商体系',
                isShow: true,
                isBack: false
            }
        }
    },
    props:{
        show: {
            type: Boolean,
            default: true
        }
    },
    created() {
        this.getNavbar
    },
    mounted() {
    },
    methods: {
        onClickLeft() {
            if(this.navbar.isBack)
            {
                try {
                    this.$router.go(-1)
                }
                catch(err) {
                    this.$router.replace('/')
                }
            }
        }
    },
    computed: {
        getNavbar() {
            this.$nextTick(() => {
                // DOM 更新完毕
                this.navbar = this.$store.state.app.navbar
            })
        }
    },
    watch: {
        'getNavbar': {
            handler(newValue) {
                console.log("监听")
                console.log(newValue)
            }
        }
    }
}